<footer *ngIf="checkShowFooter" class="footer footer-ironside" id="footer">
    <div class="container">
        <div class="footer-inner text-center">
            <p class="p-1 m-0 text-center text-white">
                © {{ currentDate | date : 'yyyy' }} Ironside Internationnal
            </p>
        </div>
    </div>
</footer>
